import store from '../store';

export const getRequestsReducer = (state = store) => state.requestsReducer

export const getRequestsTasks = (state = store) => getRequestsReducer(state).tasks
export const getSelectRequest = (state = store) => getRequestsReducer(state).selectRequest

export const getRequestsPagePopout = (state = store) => getRequestsReducer(state).requestsPagePopout
